export default "__VITE_ASSET__yrOKKIBc__"